<template>
  <div v-if="newsitem">
    <h2>News item</h2>
    <v-btn :to="{ name: 'news' }"> <v-icon>chevron_left</v-icon>News </v-btn>
    <v-btn
      @click="deleteNewsitem"
      v-if="editable && $route.params.id"
      color="error"
    >
      <v-icon>delete</v-icon>Delete
    </v-btn>
    <table v-if="$route.params.id">
      <tr>
        <td>News item id</td>
        <td>{{ newsitem.id }}</td>
      </tr>
      <tr>
        <td>Timestamp</td>
        <td>{{ newsitem.timestamp | formatDate }}</td>
      </tr>
      <tr>
        <td>User</td>
        <td>
          <EntityZ :entity="newsitem.user" v-if="newsitem.user" />
        </td>
      </tr>
    </table>
    <v-textarea
      v-model="newsitem.body"
      label="Body"
      :readonly="!editable"
      auto-grow
      outline
    />
    <v-btn @click="updateNewsitem" v-if="editable && $route.params.id">
      <v-icon>save</v-icon>Update
    </v-btn>
    <v-btn @click="createNewsitem" v-if="!$route.params.id">
      <v-icon>save</v-icon>Create
    </v-btn>
  </div>
</template>

<script>
import CREATE_NEWSITEM from "@/graphql/extras/CreateNewsItem";
import DELETE_NEWSITEM from "@/graphql/extras/DeleteNewsItem";
import NEWSITEM from "@/graphql/extras/NewsItem";
import UPDATE_NEWSITEM from "@/graphql/extras/UpdateNewsItem";
import EntityZ from "@/components/link/EntityZ";
export default {
  name: "NewsItem",
  metaInfo() {
    return {
      title: "News item",
      titleTemplate: "%s - Message - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  apollo: {
    newsItem: {
      query: NEWSITEM,
      variables() {
        return {
          id: Number(this.$route.params.id)
        };
      },
      skip() {
        return this.$route.params.id === undefined;
      },
      fetchPolicy: "cache-and-network"
    }
  },
  components: { EntityZ },
  computed: {
    editable() {
      if (this.$keycloak.hasRealmRole("news")) {
        if (
          !this.$route.params.id ||
          this.$keycloak.hasRealmRole("root") ||
          this.$keycloak.tokenParsed.entityid == this.newsitem.userid
        ) {
          return true;
        }
      }
      return false;
    }
  },
  data() {
    return {
      newsitem: { id: null, body: null }
    };
  },
  methods: {
    async deleteNewsitem() {
      if (confirm("Are you sure?")) {
        await this.$apollo.mutate({
          mutation: DELETE_NEWSITEM,
          variables: { id: Number(this.$route.params.id) }
        });
        this.$router.push({ name: "news" });
      }
    },
    async createNewsitem() {
      await this.$apollo.mutate({
        mutation: CREATE_NEWSITEM,
        variables: { body: this.newsitem.body }
      });
      // console.log(response.data)
      this.$router.push({ name: "news" });
    },
    async updateNewsitem() {
      try {
        await this.$apollo.mutate({
          mutation: UPDATE_NEWSITEM,
          variables: {
            id: Number(this.$route.params.id),
            body: this.newsitem.body
          }
        });
        // console.log(response.data)
        this.$router.push({ name: "news" });
      } catch (err) {
        console.error(err);
      }
    }
  },
  watch: {
    newsItem: {
      handler() {
        if (this.newsItem) {
          this.newsitem = JSON.parse(JSON.stringify(this.newsItem));
        }
      }
    }
  }
};
</script>
